import { render, staticRenderFns } from "./comparePersonalAccident.vue?vue&type=template&id=55246b43&"
import script from "./comparePersonalAccident.vue?vue&type=script&lang=ts&"
export * from "./comparePersonalAccident.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports